import React from 'react'
import {Flex, Text} from '../../../../vanilla'
import {RapidInfoIcon} from '../../../../components/icons'
import {useRapidDeliveryStore} from '../../../../store/hooks/useStore'
import {observer} from 'mobx-react'

export const RapidDeliveryInfo = observer(() => {
  const {rapidDeliveryMaxItems} = useRapidDeliveryStore()

  return (
    <Flex
      backgroundColor="infoSurface"
      width="full"
      alignItems="center"
      gap="4px"
      paddingX="8px"
      paddingY="8px"
      borderRadius="base"
      style={{boxSizing: 'border-box'}}
      data-test-selector="rapid-delivery-info"
      marginTop="20px"
    >
      <RapidInfoIcon flexShrink="0" aria-hidden="true" boxSize="16px" />
      <Text color="infoDefault" variant="text3" lineHeight="shorter">
        Some products may not be available for Rapid delivery.
        {rapidDeliveryMaxItems !== null && ` Max ${rapidDeliveryMaxItems} items per order.`}
      </Text>
    </Flex>
  )
})
